<template>
  <header
    class="sticky top-0 z-50 bg-color-background/95 backdrop-blur-md border-border shadow-lg w-full overflow-hidden"
  >
    <!-- بنر جشنواره فعال -->
    <!-- بنر جشنواره فعال -->
    <div
      v-if="activeCampaign && !campaignClosed"
      class="w-full relative overflow-hidden"
      style="
        background: linear-gradient(
          135deg,
          var(--color-primary) 0%,
          var(--color-secondary, var(--color-primary-dark)) 100%
        );
      "
    >
      <div class="absolute inset-0 opacity-10">
        <div
          class="absolute inset-0"
          style="
            background-image: repeating-linear-gradient(
              45deg,
              transparent,
              transparent 10px,
              rgba(255, 255, 255, 0.1) 10px,
              rgba(255, 255, 255, 0.1) 20px
            );
          "
        ></div>
      </div>

      <div class="relative z-10 py-1.5 md:py-2 px-8 md:px-12">
        <div
          class="flex items-center justify-center gap-1.5 md:gap-4 flex-wrap text-center"
        >
          <!-- بخش template - جایگزین بخش نام کمپین -->
          <div class="flex items-center gap-1.5 md:gap-2 min-w-0">
            <div
              class="relative overflow-hidden"
              :style="{
                maxWidth: 'clamp(180px, 50vw, 500px)',
              }"
            >
              <div v-if="isTextOverflowing" class="marquee-container">
                <span
                  ref="campaignNameRef"
                  class="font-bold text-white whitespace-nowrap inline-block marquee-text-reverse"
                  :style="{
                    fontSize: 'clamp(0.625rem, 2vw, 1rem)',
                  }"
                >
                  {{ activeCampaign.name }}
                </span>
              </div>
              <span
                v-else
                ref="campaignNameRef"
                class="font-bold text-white truncate block"
                :style="{
                  fontSize: 'clamp(0.625rem, 2vw, 1rem)',
                }"
              >
                {{ activeCampaign.name }}
              </span>
            </div>

            <span
              class="animate-pulse inline-flex items-center gap-0.5 md:gap-1 px-1.5 md:px-2 py-0.5 rounded-full bg-white text-[var(--color-primary)] font-black shadow-md whitespace-nowrap flex-shrink-0"
              :style="{
                fontSize: 'clamp(0.625rem, 1.8vw, 0.875rem)',
              }"
            >
              <span>{{ activeCampaign.discount }}%</span>
              <span class="hidden sm:inline font-bold">تخفیف</span>
            </span>
          </div>

          <span
            class="hidden sm:block w-px h-3 md:h-4 bg-white/30 flex-shrink-0"
          ></span>

          <router-link
            to="/Campaign"
            class="px-2 md:px-4 py-1 md:py-1.5 rounded-lg bg-white/20 hover:bg-white/30 border border-white/30 text-white font-bold transition-all whitespace-nowrap flex-shrink-0"
            :style="{
              fontSize: 'clamp(0.625rem, 1.8vw, 0.875rem)',
            }"
            @click="mobileMenuOpen = false"
          >
            <span class="hidden sm:inline">مشاهده محصولات</span>
            <span class="sm:hidden">مشاهده</span>
            <span class="inline-block mr-0.5 md:mr-1">←</span>
          </router-link>
        </div>

        <button
          @click="closeCampaignBanner"
          class="absolute left-1 md:left-4 top-1/2 -translate-y-1/2 p-0.5 md:p-1 hover:bg-white/20 rounded-full transition-colors flex-shrink-0"
          aria-label="بستن بنر تخفیف"
        >
          <X
            class="text-white"
            :style="{
              width: 'clamp(0.625rem, 2vw, 1rem)',
              height: 'clamp(0.625rem, 2vw, 1rem)',
            }"
          />
        </button>
      </div>
    </div>
    <!-- هدر اصلی -->
    <div class="w-full">
      <div
        class="flex items-stretch justify-between h-12 sm:h-14 md:h-16 px-2 sm:px-4 md:px-6 lg:px-8 xl:px-12 w-full max-w-[100vw]"
      >
        <!-- گروه چپ: لوگو و نویگیشن -->
        <div
          class="flex items-center gap-2 sm:gap-3 md:gap-4 lg:gap-6 xl:gap-8 min-w-0 flex-shrink"
        >
          <!-- Logo - فقط این بخش رو عوض کن -->
          <router-link
            to="/"
            class="flex items-center gap-2 sm:gap-3 md:gap-4 group shrink-0 self-stretch"
          >
            <div class="h-full flex items-center">
              <img
                v-if="logoUrl"
                :src="logoUrl"
                alt="Logo"
                class="object-contain"
                style="
                  max-height: 100%;
                  max-width: 120px;
                  width: auto;
                  height: auto;
                "
                @error="handleImageError"
              />
              <img
                v-else
                :src="DefaultPhotoImg"
                alt="Logo Placeholder"
                class="object-contain"
                style="
                  max-height: 100%;
                  max-width: 120px;
                  width: auto;
                  height: auto;
                "
              />
            </div>
            <h3
              class="text-sm sm:text-base md:text-lg lg:text-xl font-bold text-text-secondary hidden sm:block truncate max-w-[80px] sm:max-w-[120px] md:max-w-[150px] lg:max-w-[200px]"
            >
              {{ storeName }}
            </h3>
          </router-link>

          <!-- Navigation Links - دسکتاپ -->
          <nav class="hidden lg:flex items-center gap-0.5 xl:gap-1 2xl:gap-2">
            <router-link
              to="/"
              class="flex items-center gap-1 xl:gap-1.5 px-1.5 xl:px-2 2xl:px-3 py-1.5 xl:py-2 text-xs xl:text-sm text-text-primary hover:text-primary hover:bg-primary/5 rounded-lg transition-all duration-200 font-medium whitespace-nowrap"
            >
              <Home class="w-3.5 h-3.5 xl:w-4 xl:h-4 shrink-0" />
              <span class="hidden xl:inline">خانه</span>
            </router-link>

            <router-link
              to="/products"
              class="flex items-center gap-1 xl:gap-1.5 px-1.5 xl:px-2 2xl:px-3 py-1.5 xl:py-2 text-xs xl:text-sm text-text-primary hover:text-primary hover:bg-primary/5 rounded-lg transition-all duration-200 font-medium whitespace-nowrap"
            >
              <Package class="w-3.5 h-3.5 xl:w-4 xl:h-4 shrink-0" />
              <span class="hidden xl:inline">محصولات</span>
            </router-link>

            <router-link
              v-if="activeCampaign"
              to="/Campaign"
              class="flex items-center gap-1 xl:gap-1.5 px-1.5 xl:px-2 2xl:px-3 py-1.5 xl:py-2 text-xs xl:text-sm font-bold text-primary hover:text-primary/80 rounded-lg transition-all duration-200 relative whitespace-nowrap"
            >
              <Sparkles class="w-3.5 h-3.5 xl:w-4 xl:h-4 shrink-0" />
              <span class="hidden xl:inline">فروش ویژه</span>
              <span
                class="w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse absolute top-0.5 right-0.5 xl:top-1 xl:right-1"
              ></span>
            </router-link>

            <router-link
              to="/blog"
              class="flex items-center gap-1 xl:gap-1.5 px-1.5 xl:px-2 2xl:px-3 py-1.5 xl:py-2 text-xs xl:text-sm text-text-primary hover:text-primary hover:bg-primary/5 rounded-lg transition-all duration-200 font-medium whitespace-nowrap"
            >
              <BookOpen class="w-3.5 h-3.5 xl:w-4 xl:h-4 shrink-0" />
              <span class="hidden xl:inline">وبلاگ</span>
            </router-link>

            <router-link
              to="/contact"
              class="flex items-center gap-1 xl:gap-1.5 px-1.5 xl:px-2 2xl:px-3 py-1.5 xl:py-2 text-xs xl:text-sm text-text-primary hover:text-primary hover:bg-primary/5 rounded-lg transition-all duration-200 font-medium whitespace-nowrap"
            >
              <MessageCircle class="w-3.5 h-3.5 xl:w-4 xl:h-4 shrink-0" />
              <span class="hidden xl:inline">تماس با ما</span>
            </router-link>
          </nav>
        </div>

        <!-- گروه راست: جستجو و آیکون‌ها -->
        <div class="flex items-center gap-1 sm:gap-1.5 md:gap-2 shrink-0">
          <!-- Search Bar (Desktop) -->
          <div
            class="hidden md:flex items-center bg-background-2 rounded-full px-2 lg:px-3 py-1 md:py-1.5 lg:py-2 border border-border focus-within:border-primary transition-all cursor-pointer shadow-sm w-24 sm:w-28 md:w-32 lg:w-40 xl:w-48 2xl:w-56"
            @click="focusSearchInput"
          >
            <Search
              class="w-3.5 h-3.5 md:w-4 md:h-4 text-primary ml-1 lg:ml-2 shrink-0"
            />
            <input
              ref="searchInputRef"
              type="text"
              placeholder="جستجو..."
              class="bg-transparent outline-none text-xs md:text-sm w-full text-text-primary placeholder-text-secondary min-w-0"
              @keyup.enter="handleSearch"
            />
          </div>

          <!-- دکمه ورود / ثبت‌نام (دسکتاپ) -->
          <button
            v-if="!isLoggedIn && !isMobile"
            @click="$router.push('/login')"
            class="hidden md:flex items-center gap-1 lg:gap-1.5 px-2 lg:px-3 xl:px-4 py-1 md:py-1.5 lg:py-2 bg-primary text-white rounded-full text-xs lg:text-sm font-bold hover:bg-primary/90 transition shadow-md whitespace-nowrap shrink-0"
          >
            <User class="w-3.5 h-3.5 lg:w-4 lg:h-4 shrink-0" />
            <span class="hidden lg:inline">ورود</span>
            <span class="hidden xl:inline">/ ثبت‌نام</span>
          </button>

          <!-- پروفایل (دسکتاپ) -->
          <router-link
            v-if="isLoggedIn && !isMobile"
            to="/profile"
            class="relative p-1.5 lg:p-2 hover:bg-primary/10 rounded-full transition-colors shrink-0"
          >
            <User
              class="w-4 h-4 sm:w-5 sm:h-5 text-text-primary hover:text-primary"
            />
          </router-link>

          <!-- سبد خرید -->
          <router-link
            v-if="!isLeadStore"
            to="/cart"
            class="relative p-1.5 lg:p-2 hover:bg-primary/10 rounded-full transition-colors shrink-0"
          >
            <ShoppingBag
              class="w-4 h-4 sm:w-5 sm:h-5 text-text-primary hover:text-primary"
            />
            <span
              v-if="cartCount > 0"
              class="absolute -top-0.5 -right-0.5 md:-top-1 md:-right-1 bg-red-500 text-white text-[10px] md:text-xs font-bold rounded-full min-w-[16px] md:min-w-[18px] h-[16px] md:h-[18px] flex items-center justify-center px-1 shadow-sm"
            >
              {{ cartCount }}
            </span>
          </router-link>

          <!-- Mobile menu button -->
          <button
            @click="mobileMenuOpen = !mobileMenuOpen"
            class="lg:hidden p-1.5 hover:bg-primary/10 rounded-full transition-colors shrink-0"
          >
            <Menu class="w-4 h-4 sm:w-5 sm:h-5 text-text-primary" />
          </button>
        </div>
      </div>
    </div>
  </header>

  <!-- Mobile Sidebar Menu -->
  <Teleport to="body">
    <Transition name="sidebar-fade">
      <div
        v-if="mobileMenuOpen"
        class="lg:hidden fixed inset-0 z-[9998] bg-black/70 backdrop-blur-md"
        @click="mobileMenuOpen = false"
      ></div>
    </Transition>

    <Transition name="sidebar-slide">
      <aside
        v-if="mobileMenuOpen"
        class="lg:hidden fixed top-0 left-0 bottom-0 z-[9999] w-[60%] max-w-[320px] bg-color-background/95 backdrop-blur-xl shadow-2xl flex flex-col"
      >
        <div
          class="flex items-center justify-between px-4 py-3.5 border-b border-border shrink-0 bg-color-background/60"
        >
          <h3 class="font-bold text-sm text-text-primary truncate">
            {{ storeName }}
          </h3>
          <button
            @click="mobileMenuOpen = false"
            class="p-2 rounded-full hover:bg-primary/10 active:scale-90 transition-all"
            aria-label="بستن منو"
          >
            <X class="w-5 h-5 text-text-primary" />
          </button>
        </div>

        <div class="flex-1 overflow-y-auto py-3 px-3">
          <div class="flex flex-col space-y-0.5 md:space-y-1">
            <router-link
              to="/"
              class="flex items-center gap-3 text-xs md:text-sm text-text-primary hover:text-primary py-2.5 md:py-3 px-3 md:px-4 rounded-lg hover:bg-primary/5 transition-all font-medium"
              @click="mobileMenuOpen = false"
            >
              <Home class="w-4 h-4 md:w-5 md:h-5 shrink-0" />
              <span>خانه</span>
            </router-link>

            <router-link
              to="/products"
              class="flex items-center gap-3 text-xs md:text-sm text-text-primary hover:text-primary py-2.5 md:py-3 px-3 md:px-4 rounded-lg hover:bg-primary/5 transition-all font-medium"
              @click="mobileMenuOpen = false"
            >
              <Package class="w-4 h-4 md:w-5 md:h-5 shrink-0" />
              <span>محصولات</span>
            </router-link>

            <router-link
              v-if="activeCampaign"
              to="/Campaign"
              class="flex items-center justify-between py-2.5 md:py-3 px-3 md:px-4 rounded-lg my-1.5 md:my-2 text-white font-bold"
              style="
                background: linear-gradient(
                  135deg,
                  var(--color-primary),
                  var(--color-secondary, var(--color-primary-dark))
                );
              "
              @click="mobileMenuOpen = false"
            >
              <span class="flex items-center gap-3 text-xs md:text-sm">
                <Sparkles class="w-4 h-4 md:w-5 md:h-5 shrink-0" />
                فروش ویژه
              </span>
              <span
                class="bg-white text-[var(--color-primary)] px-1.5 md:px-2 py-0.5 rounded-lg text-[10px] md:text-xs font-black whitespace-nowrap"
              >
                {{ activeCampaign.discount }}%
              </span>
            </router-link>

            <router-link
              to="/blog"
              class="flex items-center gap-3 text-xs md:text-sm text-text-primary hover:text-primary py-2.5 md:py-3 px-3 md:px-4 rounded-lg hover:bg-primary/5 transition-all font-medium"
              @click="mobileMenuOpen = false"
            >
              <BookOpen class="w-4 h-4 md:w-5 md:h-5 shrink-0" />
              <span>وبلاگ</span>
            </router-link>

            <router-link
              to="/contact"
              class="flex items-center gap-3 text-xs md:text-sm text-text-primary hover:text-primary py-2.5 md:py-3 px-3 md:px-4 rounded-lg hover:bg-primary/5 transition-all font-medium"
              @click="mobileMenuOpen = false"
            >
              <MessageCircle class="w-4 h-4 md:w-5 md:h-5 shrink-0" />
              <span>تماس با ما</span>
            </router-link>

            <div
              class="flex items-center bg-background-2 rounded-full px-3 md:px-4 py-2.5 md:py-3 border border-border mt-2 md:mt-3 shadow-sm"
            >
              <Search
                class="w-3.5 h-3.5 md:w-4 md:h-4 text-primary ml-2 shrink-0"
              />
              <input
                ref="mobileSearchInputRef"
                type="text"
                placeholder="جستجو..."
                class="bg-transparent outline-none text-xs md:text-sm flex-1 text-text-primary"
                @keyup.enter="handleSearch"
              />
            </div>

            <button
              v-if="!isLoggedIn"
              @click="
                $router.push('/login');
                mobileMenuOpen = false;
              "
              class="w-full mt-3 py-2.5 md:py-3 bg-primary text-white rounded-xl text-xs md:text-sm font-bold hover:bg-primary/90 transition shadow-md flex items-center justify-center gap-2"
            >
              <User class="w-4 h-4 md:w-5 md:h-5 shrink-0" />
              <span>ورود / ثبت‌نام</span>
            </button>
          </div>
        </div>
      </aside>
    </Transition>
  </Teleport>

  <!-- Mobile Bottom Navigation -->
  <Teleport to="body">
    <nav
      v-if="isMobile"
      class="fixed inset-x-0 bottom-0 z-[9999] bg-color-background/95 backdrop-blur-md border-t border-border shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)]"
      style="padding-bottom: env(safe-area-inset-bottom)"
    >
      <div
        class="flex justify-around items-center h-14 sm:h-16 max-w-lg mx-auto"
      >
        <router-link
          to="/"
          class="flex flex-col items-center justify-center w-full h-full transition-all duration-300 gap-0.5"
          :class="$route.path === '/' ? 'text-primary' : 'text-text-secondary'"
        >
          <Home class="w-5 h-5 sm:w-6 sm:h-6" />
          <span class="text-[10px] sm:text-xs font-medium">خانه</span>
        </router-link>

        <router-link
          to="/products"
          class="flex flex-col items-center justify-center w-full h-full transition-all duration-300 gap-0.5"
          :class="
            $route.path.startsWith('/products')
              ? 'text-primary'
              : 'text-text-secondary'
          "
        >
          <Package class="w-5 h-5 sm:w-6 sm:h-6" />
          <span class="text-[10px] sm:text-xs font-medium">محصولات</span>
        </router-link>

        <router-link
          v-if="!isLeadStore"
          to="/cart"
          class="flex flex-col items-center justify-center w-full h-full transition-all duration-300 gap-0.5 relative"
          :class="
            $route.path === '/cart' ? 'text-primary' : 'text-text-secondary'
          "
        >
          <ShoppingBag class="w-5 h-5 sm:w-6 sm:h-6" />
          <span class="text-[10px] sm:text-xs font-medium">سبد خرید</span>
          <span
            v-if="cartCount > 0"
            class="absolute top-1 right-1/4 sm:right-1/3 bg-red-500 text-white text-[10px] font-bold rounded-full min-w-[16px] h-[16px] flex items-center justify-center px-1"
          >
            {{ cartCount }}
          </span>
        </router-link>

        <router-link
          :to="isLoggedIn ? '/profile' : '/login'"
          class="flex flex-col items-center justify-center w-full h-full transition-all duration-300 gap-0.5"
          :class="
            $route.path.includes('profile') || $route.path === '/login'
              ? 'text-primary'
              : 'text-text-secondary'
          "
        >
          <User class="w-5 h-5 sm:w-6 sm:h-6" />
          <span class="text-[10px] sm:text-xs font-medium">{{
            isLoggedIn ? "پروفایل" : "ورود"
          }}</span>
        </router-link>
      </div>
    </nav>
  </Teleport>
</template>

<script setup>
import { ref, onMounted, computed, onUnmounted, nextTick, watch } from "vue";
import { useRouter } from "vue-router";
import {
  Search,
  User,
  ShoppingBag,
  Menu,
  Home,
  BookOpen,
  Sparkles,
  X,
  Package,
  MessageCircle,
} from "lucide-vue-next";
import ShopService from "@/api/services/shopService";
import authService from "@/api/services/authService";
import DefaultPhotoImg from "@/assets/Defaultphoto.png";

const router = useRouter();
const mobileMenuOpen = ref(false);
const cartCount = ref(0);
const isMobile = ref(window.innerWidth < 1024);

const searchInputRef = ref(null);
const mobileSearchInputRef = ref(null);

const storeName = ref(localStorage.getItem("shop_name") || "فروشگاه من");
const logoUrl = ref(null);
const activeCampaign = ref(null);
const campaignClosed = ref(false);

const isLoggedIn = computed(() => authService.isLoggedIn());
const isLeadStore = computed(() => ShopService.isLeadStore());
const currentUser = computed(() => authService.getCurrentUser());

// متغیرهای جدید برای marquee
const campaignNameRef = ref(null);
const isTextOverflowing = ref(false);

const isValidCampaign = (campaign) => {
  if (!campaign || typeof campaign !== "object") return false;
  if (!campaign.name || campaign.name.trim() === "") return false;
  if (
    campaign.discount === null ||
    campaign.discount === undefined ||
    isNaN(campaign.discount) ||
    Number(campaign.discount) <= 0
  ) {
    return false;
  }
  if (campaign.end) {
    const endTime = new Date(campaign.end).getTime();
    if (endTime < Date.now()) return false;
  }
  return true;
};

const checkTextOverflow = () => {
  nextTick(() => {
    if (campaignNameRef.value) {
      const textElement = campaignNameRef.value;
      const containerElement = textElement.parentElement;
      if (containerElement) {
        isTextOverflowing.value =
          textElement.scrollWidth > containerElement.clientWidth;
      }
    }
  });
};

const fetchActiveCampaign = async () => {
  try {
    const response = await ShopService.getShopCampain();
    let campaign = null;

    if (Array.isArray(response)) {
      campaign = response.find((c) => isValidCampaign(c)) || null;
    } else if (response && typeof response === "object") {
      campaign = isValidCampaign(response) ? response : null;
    }

    activeCampaign.value = campaign;
    // بعد از لود شدن کمپین، چک کن
    checkTextOverflow();
  } catch (error) {
    console.error("Error fetching active campaign:", error);
    activeCampaign.value = null;
  }
};

const closeCampaignBanner = () => {
  campaignClosed.value = true;
  sessionStorage.setItem("campaignBannerClosed", "true");
};

const updateCartCount = async () => {
  try {
    const cartData = await ShopService.getCart({ noCache: true });

    if (cartData && Array.isArray(cartData.items)) {
      cartCount.value = cartData.items.reduce(
        (sum, item) => sum + Number(item.quantity || 0),
        0
      );
    } else {
      cartCount.value = 0;
    }
  } catch (err) {
    console.error("Error updating cart:", err);
  }
};

const fetchStoreData = async () => {
  try {
    const data = await ShopService.getStore();
    if (data) {
      storeName.value = data.name || data.store_name || storeName.value;
      if (data.logo) logoUrl.value = data.logo;
      localStorage.setItem("shop_name", storeName.value);
      if (data.logo) localStorage.setItem("shop_logo", data.logo);
    }
  } catch (error) {
    console.error("Error fetching store data:", error);
  }

  try {
    updateCartCount();
  } catch (err) {
    console.error("Error fetching cart:", err);
  }
};

const handleImageError = (e) => {
  e.target.src = DefaultPhotoImg;
  logoUrl.value = null;
};

const handleResize = () => {
  isMobile.value = window.innerWidth < 1024;
  // چک overflow موقع resize
  checkTextOverflow();
};

const focusSearchInput = () => {
  if (searchInputRef.value) {
    searchInputRef.value.focus();
  }
};

const handleSearch = () => {
  let query = "";

  // دسکتاپ
  if (searchInputRef.value && searchInputRef.value.value.trim()) {
    query = searchInputRef.value.value.trim();
  }
  // موبایل
  else if (
    mobileSearchInputRef.value &&
    mobileSearchInputRef.value.value.trim()
  ) {
    query = mobileSearchInputRef.value.value.trim();
  }

  if (query) {
    // *** مسیر رو کامل با /products شروع کن ***
    router.push({
      path: "/products",
      query: { search: query },
    });

    // پاک کردن inputها
    if (searchInputRef.value) searchInputRef.value.value = "";
    if (mobileSearchInputRef.value) mobileSearchInputRef.value.value = "";
    mobileMenuOpen.value = false;
  }
};

// watch برای وقتی activeCampaign عوض میشه
watch(activeCampaign, () => {
  checkTextOverflow();
});

onMounted(() => {
  fetchStoreData();
  fetchActiveCampaign();
  updateCartCount();

  if (sessionStorage.getItem("campaignBannerClosed") === "true") {
    campaignClosed.value = true;
  }

  window.addEventListener("resize", handleResize);
  window.addEventListener("cart-updated", (event) => {
    const item = event.detail?.item;
    if (item) {
      updateCartCount();
    }
  });
});

onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
  window.removeEventListener("cart-updated", updateCartCount);
});
</script>

<style scoped>
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease;
}

.slide-down-enter-from,
.slide-down-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

.sidebar-fade-enter-active,
.sidebar-fade-leave-active {
  transition: opacity 0.35s ease;
}
.sidebar-fade-enter-from,
.sidebar-fade-leave-to {
  opacity: 0;
}

.sidebar-slide-enter-active,
.sidebar-slide-leave-active {
  transition: transform 0.45s cubic-bezier(0.22, 1, 0.36, 1);
}
.sidebar-slide-enter-from,
.sidebar-slide-leave-to {
  transform: translateX(-100%);
}
.marquee-wrapper {
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
}

.marquee-text {
  display: inline-block;
  animation: marquee 10s linear infinite;
  padding-left: 100%;
}
/* اضافه کن به <style scoped> */
.marquee-container {
  width: 100%;
  overflow: hidden;
}

.marquee-text-reverse {
  display: inline-block;
  animation: marquee-reverse 8s linear infinite;
  /* تغییر: متن از همون اول داخل container باشه */
  padding-right: 0;
}

@keyframes marquee-reverse {
  0% {
    /* شروع از سمت راست container */
    transform: translateX(-100%);
  }
  100% {
    /* تمام شدن در سمت چپ container */
    transform: translateX(100%);
  }
}

/* توقف اسکرول موقع هاور */
.marquee-text-reverse:hover {
  animation-play-state: paused;
}
@supports (padding-bottom: env(safe-area-inset-bottom)) {
  .safe-bottom {
    padding-bottom: env(safe-area-inset-bottom);
  }
}
</style>